<script setup lang="ts">
/*
* Компонент CalendarSidebarDatePicker - мини-календарь в сайдбаре календарей
*
* Общий для календаря аудитов, графика проверок и общего календаря.
* Компонент только отдаёт выбранную дату наружу, навигацией FullCalendar
* управляет родитель.
*/

const selectedDate = defineModel<Date>({ required: true })

const onSelect = (value: unknown) => {
  const date = value instanceof Date ? value : new Date(String(value))
  if (Number.isNaN(date.getTime())) return

  selectedDate.value = date
}
</script>

<template>
  <div class="d-flex justify-center pa-2">
    <VDatePicker
      :model-value="selectedDate"
      class="sidebar-date-picker"
      hide-header
      show-adjacent-months
      @update:model-value="onSelect"
    />
  </div>
</template>

<style scoped lang="scss">
.sidebar-date-picker {
  inline-size: 100%;
}
</style>
